import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerPadding: {
      padding: '15px'
    },
    gridContainerPadding: {
      padding: 15
    },
    gridContainerBackgroundColor: {
      backgroundColor: '#FFFFFF'
    },
    processSelectfieldWidth: {
      width: '100%'
    },
    chartContainer: {
      padding: 15,
      backgroundColor: '#FFFFFF',
      borderRadius: 5
    },
    publishUrlButtonWrapper: {
      [theme.breakpoints.only('xs')]: {
        textAlign: 'right'
      }
    },
    publishUrlButton: {
      textDecoration: 'underline'
    }
  })
);
